module.exports = __webpack_public_path__ + "assets/pdf-list.6d95f37c.svg";